import { Timestamp } from '@google-cloud/firestore';
import { CboRole, PersonaRole, SiteInfo } from './cboPermission';

export type SitesById = { [euid: string]: SiteInfo };

export interface AuthData {
  roles: CboRole[];
  personas: PersonaRole[];
  sites: SitesById;
  refreshed: Timestamp;
  expires: Timestamp;
}
export const authCollectionName = 'UserAuthCache';
export const orgAuthCollectionName = 'Orgs';
export function getAuthDocPath(userId: string, orgId: string) {
  return `${authCollectionName}/${userId}/${orgAuthCollectionName}/${orgId}`;
}
